// extracted by mini-css-extract-plugin
export default {"formBox":"B9AO9UIcG7vzKDf1qiQA"};